<div class="client-info-form">
  <label class="form-input-wrapper">
    <span class="form-input-label">Display Name:</span>
    <input *ngIf="!isLoading; else inputSkeleton" [value]="fullName" readonly class="form-input_md" />
  </label>

  <label class="form-input-wrapper">
    <span class="form-input-label">Notification Email:</span>
    <input
      *ngIf="!isLoading; else inputSkeleton"
      [value]="clientProfileInfo?.billingEmail"
      readonly
      class="form-input_md"
    />
  </label>

  <label class="form-input-wrapper">
    <span class="form-input-label">Phone:</span>
    <input
      *ngIf="!isLoading; else inputSkeleton"
      [value]="clientProfileInfo?.phoneNumber"
      readonly
      class="form-input_md"
    />
  </label>

  <label class="form-input-wrapper">
    <span class="form-input-label">Company:</span>
    <input
      *ngIf="!isLoading; else inputSkeleton"
      [value]="clientProfileInfo?.companyName"
      readonly
      class="form-input_md"
    />
  </label>

  <label class="form-input-wrapper">
    <span class="form-input-label">Fax time zone:</span>
    <input
      *ngIf="!isLoading; else inputSkeleton"
      [value]="clientProfileInfo?.timeZone"
      readonly
      class="form-input_md"
    />
  </label>

  <div class="client-info-form-buttons">
    <button type="button" class="btn_primary btn_lg client-info-form-button" (click)="editClick.emit()">
      Edit Info
    </button>
  </div>
</div>

<ng-template #inputSkeleton>
  <div class="skeleton client-info-form-input-skeleton"></div>
</ng-template>
